module.exports = __webpack_public_path__ + "img/restaurant_signaturemenu_image26.37b3fd89.jpg";